// IE 11 polyfill
// https://stackoverflow.com/questions/41142932/ie-supports-foreach-when-invoked-fromthe-console-but-not-when-called-from-t

// eslint-disable-next-line consistent-return
export function objectToArray(object) {
	if (!Array.forEach) {
		return [].slice.call(object);
	}
}
